<template>
    <!-- 首页 -->
    <div>
        <myheader :messages="parentMessage"></myheader>
        <!--  -->
        <div class="bannerbox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
            <div class="swiper mySwiper swiper-container">
            	<div class="swiper-wrapper">
            		<div class="swiper-slide">
                        <div class="wker">
                            <div class="mk">
                                <div class="ter">
                                    <div class="h ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0s">互联网基础应用解决方案优秀提供商</div>
                                    <div class="p ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0.2s">专注于互联网、移动互联网的信息应用、行业软件定制及软件运维等服务，已为多家政企单位提供相应的技术解决方案，全方位为客户提供可拓展的技术支持。</div>
                                    <div class="more ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0.4s">
                                        <div class="a a1" @click="kefuclick"><i>在线咨询</i></div>
                                        <div class="a" @click="baojia">获取报价</div>
                                    </div>
                                    <div class="m ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="1" swiper-animate-delay="0.6s">多年开发与技术服务经验， 创造价值产品与用户之间的共鸣<br/>咨询电话：18919819927</div>
                                </div>
                                <div class="img">
                                    <div class="em em1"><img src="../assets/12.png" ></div>
                                    <div class="em em2"><img src="../assets/13.png" ></div>
                                    <div class="em em3"><img src="../assets/14.png" ></div>
                                    <div class="em em4"><img src="../assets/15.png" ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
                <!-- <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div> -->
            </div>
        </div>
        <div class="indexmaxlistone paddingtop80">
            <div class="cont w1750">
                <div class="titlebox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="h">技术服务&产品</div>
                    <div class="p">一个好的策划方案无法满足每个人对个性的追求，倾听您的需求，做您满意的产品，打造好的产品体验</div>
                </div>
                <div class="list">
                    <div class="wli wli1 clearfix wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                            <div class="mk">
                                <div class="h">WEB开发</div>
                                <div class="n">PC网站｜H5<br/>B/S架构应用系统</div>
                                <div class="p">
                                    <p>网络应用程序不需要任何复杂的“展开”过程，你所需要的只是一个适用的浏览器。</p>
                                    <p>Web应用程序是一种可以通过Web访问的应用程序，程序的最大好处是用户很容易访问应用程序，用户只需要有浏览器即可，不需要再安装其他软件。</p>
                                </div>
                                <div class="moxmaxbox" @click="kefuclick"><i>在线咨询</i></div>
                            </div>
                        </div>
                        <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                            <img src="../assets/3.png" alt="" class="img1">
                            <img src="../assets/2.png" alt="" class="img2">
                        </div>
                    </div>
                    <div class="wli wli2 clearfix wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                            <div class="mk">
                                <div class="h">微信开发</div>
                                <div class="n">公众号｜小程序｜企业微信</div>
                                <div class="p">
                                    <p>小程序是一种不需要下载安装即可使用的应用，它实现了应用“触手可及”的梦想，用户扫一扫或者搜一下即可打开应用。也体现了“用完即走”的理念。小程序能够实现消息通知、线下扫码、公众号关联等七大功能。其中，通过公众号关联，用户可以实现公众号与小程序之间相互跳转。</p>
                                </div>
                            </div>
                        </div>
                        <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                            <img src="../assets/1.png" alt="" class="img1">
                            <img src="../assets/4.png" alt="" class="img2">
                        </div>
                    </div>
                    <div class="wli wli3 clearfix wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                            <div class="mk">
                                <div class="h">APP开发</div>
                                <div class="n">Android｜IOS</div>
                                <div class="p">
                                    <p>专注打造有品质的app开发产品，提供一体化的互联网+技术解决方案，让您的项目从构念到产品快速启动、轻松落地！明确目标群体诉求,解决用户痛点,以合适的视觉表现和流畅的用户体验，体现出您的核心竞争力。。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wli wli4 clearfix wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                            <div class="mk">
                                <div class="h">可视化数据看版<br/>设计开发</div>
                                <div class="p">
                                    <p>帮助各行业领域管理者从多个方面提升智能化决策能力，如监控中心、指挥中心、调度中心等重要场所，数据大屏可视化系统已经成为信息可视化不可或缺的展示平台。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wli wli5 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="text wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                            <div class="mk">
                                <div class="h">云产品</div>
                                <div class="n">域名（ICP/公网备案）｜云服务器<br/>SSL安全证｜存储CDN｜API<br/>数据库｜安全运维</div>
                                <div class="p">
                                    <p>竭力为用户提供便捷、安全、稳定的云技术服务及解决方案！</p>
                                    <p>按需推荐使用云产品，如域名，云计算资源、存储资源、数据库资源、网络资源等，及时有效响应企业业务需求,高效利用计算资源以满足业务要求。</p>
                                </div>
                                <div class="icon">
                                    <div class="m"><img src="../assets/images/w20.png" alt=""></div>
                                </div>
                            </div>
                        </div>
                        <div class="img wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                            <img src="../assets/images/w14.png" alt="" class="img1">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="indexmaxlistwo paddingtop80 margin85">
            <div class="cont">
                <div class="titlebox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="h">业务开发流程</div>
                    <div class="p">定制不只是设计 而是对品质的追求</div>
                </div>
                <div class="list wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="mker w1366 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                        <div class="swiper-container swiper">
                        	<div class="swiper-wrapper">
                        		<div class="swiper-slide">
                                    <div class="wker">
                                        <div class="mk">
                                            <div class="text">
                                                <div class="n">沟通</div>
                                                <div class="h">你想要的产品的应用场景是什么？</div>
                                                <div class="p">我们的产品经理会和您整体确认需求，详细了解您软件的应用环境以及实施细节。然后会以书面的形式，形成项目需求书，需求书会详细描述项目的所有功能和细节以及报价。 </div>
                                            </div>
                                            <div class="img">
                                                <img src="../assets/images/w1.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="wker">
                                        <div class="mk">
                                            <div class="text">
                                                <div class="n">设计</div>
                                                <div class="h">产品经理对需求进行分析以及UI/UX方案设计</div>
                                                <div class="p">设计师会深入分析并理解产品的功能需求、目标用户群体以及业务目标，基于这些理解来规划和创造用户界面（UI）和用户体验（UX）的设计方案。这个过程旨在确保设计不仅满足产品的功能性要求，而且能够提供直观、易用且吸引人的界面和愉悦的用户体验。</div>
                                            </div>
                                            <div class="img">
                                                <img src="../assets/images/w2.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="wker">
                                        <div class="mk">
                                            <div class="text">
                                                <div class="n">开发</div>
                                                <div class="h">程序员根据开发文档进行系统性的软件开发</div>
                                                <div class="p">程序员按照预定的开发流程和标准，有计划、有步骤地进行编码、测试、调试和优化等工作，以确保最终开发出的软件能够符合设计要求，具备良好的性能、稳定性和用户体验。</div>
                                            </div>
                                            <div class="img">
                                                <img src="../assets/images/w3.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="wker">
                                        <div class="mk">
                                            <div class="text">
                                                <div class="n">部署</div>
                                                <div class="h">产品部署在相关的运行环境中让目标用户访问</div>
                                                <div class="p">项目/产品发布到生产环境中，过程涉及硬件、软件、网络等多个方面的配置和准备，以确保系统能够正常启动、处理用户请求并满足业务需求。</div>
                                            </div>
                                            <div class="img">
                                                <img src="../assets/images/w4.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide">
                                    <div class="wker">
                                        <div class="mk">
                                            <div class="text">
                                                <div class="n">运维</div>
                                                <div class="h">产品运营和维护以及售后怎么办？</div>
                                                <div class="p">组建技术服务微信群，客户有需求以及问题直接在群沟通 <br/>提供全方位的产品使用培训 <br/>BUG终身免费修复并更新 <br/>长期提供技术支持和基础指导服务 <br/>当产品需要迭代时免费提供技术方案和报价</div>
                                            </div>
                                            <div class="img">
                                                <img src="../assets/images/w5.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>  
                            <div class="swiper-pagination"></div>
                        </div>
                    </div>
                    <div class="icon">
                        <div class="li" v-for="(item,index) in iconlist" :key="index" :class="[iconindex==index?'cur':'']">{{item}}</div><!-- @click="iconclick(index)"-->
                    </div>
                </div>
            </div>
        </div>       
        <div class="indexmaxlisthree paddingtop80">
            <div class="cont w1366">
                <div class="titlebox wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="h">一些经典案例</div>
                    <div class="p">用设计满足需求，以策略思维呈现品牌百分百定制开发，一对一的专业设计，全程项目跟踪，集锦用专业和态度为您提供优质的服务</div>
                </div>
                <div class="list wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                    <div class="li" v-for="(item,index) in caseindex" :key="index" @click="casedataclick(item.id)">
                        <div class="m"><img :src="item.pic" alt=""></div>
                        <div class="ter">
                            <div class="h">{{item.title}}</div>
                            <div class="icon">
                                <i v-for="items in item.tags">{{items}}</i>
                            </div>
                        </div>
                    </div>
                    <div class="more">
                        <div class="mk">
                            <div class="m" @click="imgaclick(imgida)"><img :src="imgcasea" alt=""></div>
                            <div class="m" @click="imgaclick(imgidb)"><img :src="imgcaseb" alt=""></div>
                            <div class="m" @click="imgaclick(imgidc)"><img :src="imgcasec" alt=""></div>
                            <div class="a" @click="indexcaseclick">MORE</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--  -->
        <myfooter></myfooter>
        <!--  -->
        <upsform :upunm="baoMessage" @updateEvent="handleUpdate"></upsform>
    </div>
</template>

<script>
    import myfooter from './footer.vue'
    import myheader from './header.vue'
    import upsform from './upform.vue'
    
    export default {
        data() {
            return {
                iconlist: ['沟通', '设计', '开发', '部署', '运维'],
                iconindex: 0,
                parentMessage: 0,
                baoMessage: false,
                querInfo: {
                    classifyid: '',
                    pageNum: 1,
                    pageSize: 8
                },
                caseindex: [],
                imgcasea: '',
                imgcaseb: '',
                imgcasec: '',
                imgida: '',
                imgidb: '',
                imgidc: ''
            }
        },
        created() {
            this.getCaseindex()
        },
        methods: {
            handleUpdate(updatedValue) {
                this.baoMessage = updatedValue; // 更新父组件的Prop值
            },
            baojia() {
                this.baoMessage = true;
            },
            async getCaseindex(){
                var url = `/api/case/list?classifyid=${this.querInfo.classifyid}&pageNum=${this.querInfo.pageNum}&pageSize=${this.querInfo.pageSize}`
                const { data: res } = await this.$http.post(url)
                
                if(res.data.code !== 200){
                    return alert('获取案例失败！')
                }
                
                this.caseindex = res.data.rows
                this.imgcasea = res.data.rows[5].pic
                this.imgcaseb = res.data.rows[6].pic
                this.imgcasec = res.data.rows[7].pic
                this.imgida = res.data.rows[5].id
                this.imgidb = res.data.rows[6].id
                this.imgidc = res.data.rows[7].id
                
            },
            indexcaseclick(){
                this.$router.push('/case').catch(()=>{ })
                window.scrollTo(0,0);
            },
            casedataclick(id){
                const { href } = this.$router.resolve({
                    path: '/casedata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
            imgaclick(id){
                const { href } = this.$router.resolve({
                    path: '/casedata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
            imgbclick(id){
                const { href } = this.$router.resolve({
                    path: '/casedata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
            imgcclick(id){
                const { href } = this.$router.resolve({
                    path: '/casedata',
                    query: { id }
                })
                window.open(href, '_blank', 'noopener')
            },
            kefuclick(){
                const url = 'https://p.qiao.baidu.com/cps4/chatIndex?siteToken=fa6b3d5361002f77431328216553694d&speedLogId=16216501944184228_1621650194418_93941&eid=25401671&reqParam=%7B%22from%22%3A0%2C%22sid%22%3A%22-100%22%2C%22tid%22%3A%22-1%22%2C%22ttype%22%3A1%2C%22siteId%22%3A%2211856238%22%2C%22userId%22%3A%2225401671%22%2C%22pageId%22%3A0%7D';
                // window.location.href = url;
                window.open(url)
            }
        },
        components: {
        	myfooter, myheader, upsform
        }
    }
</script>

<style>
</style>
